import { Toast } from 'antd-mobile';
import { fetchGiftInfo, fetchGiftRankList } from '@/services/activity';

export default {
  namespace: 'activityGiftList',
  state: {
    endTime: 0,
    musicUrl: '',
    title: '',
    titleUrl: '',
    rules: '',
    childPageUrl: '',
    childBgColor: '',
    gifts: [],
    ranks: [],
    selfInfo: {},
    receiveRewards: [],
    sendRewards: [],
    lastId: '',
    status: 0,
    limitedGiftBackgroundImage: 'https://www.cdnmole.com/online/cms/image/c39d93d7790cd339011a8e31a9e5ead0.png',
    tabLeftImg: 'https://www.cdnmole.com/online/cms/image/f9bef4ce2412643980d64a02d2b9be9f.png',
    tabRightImg: 'https://www.cdnmole.com/online/cms/image/f9bef4ce2412643980d64a02d2b9be9f.png',
    limitedAndTabColor: '#D4BFFF',
    tabUnActiveColor: '#D4BFFF',
    pageBackgroundColor: 'linear-gradient(89.4deg, #42324E 0.64%, #232128 99.6%)',
    timeBorderColor: '#FFED8E',
    timeBackgroundColor: 'rgba(86, 0, 0, 0.4)',
    meBackgroundImg: 'https://www.cdnmole.com/online/cms/image/1d9b0dcaf30d6502922de17c44c060f0.png',
    timeNumColor: '#F0DD2C',
    timeUnitColor: '#fff',
    coinColor: '#F0C52C',
    nameAndRankColor: '#D4BFFF',
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        endTime: payload.endTime || 0,
        musicUrl: payload.musicUrl,
        title: payload.title || '',
        titleUrl: payload.titleUrl,
        rules: payload.rules,
        childPageUrl: payload.childPageUrl || '',
        gifts: payload.gifts || [],
        receiveRewards: payload.receiveRewards || [],
        sendRewards: payload.sendRewards || [],
        childBgColor: payload.childBgColor || '',
        status: payload.status || 0,
        limitedGiftBackgroundImage: payload.limitedGiftBackgroundImage || 'https://www.cdnmole.com/online/cms/image/c39d93d7790cd339011a8e31a9e5ead0.png',
        tabLeftImg: payload.tabLeftImg || 'https://www.cdnmole.com/online/cms/image/f9bef4ce2412643980d64a02d2b9be9f.png',
        tabRightImg: payload.tabRightImg || 'https://www.cdnmole.com/online/cms/image/f9bef4ce2412643980d64a02d2b9be9f.png',
        limitedAndTabColor: payload.limitedAndTabColor || '#D4BFFF',
        tabUnActiveColor: payload.tabUnActiveColor || '#D4BFFF',
        pageBackgroundColor: payload.pageBackgroundColor || 'linear-gradient(89.4deg, #42324E 0.64%, #232128 99.6%)',
        timeBorderColor: payload.timeBorderColor || '#FFED8E',
        timeBackgroundColor: payload.timeBackgroundColor || 'rgba(86, 0, 0, 0.4)',
        meBackgroundImg: payload.meBackgroundImg || 'https://www.cdnmole.com/online/cms/image/1d9b0dcaf30d6502922de17c44c060f0.png',
        timeNumColor: payload.timeNumColor || '#F0DD2C',
        timeUnitColor: payload.timeUnitColor || '#fff',
        coinColor: payload.coinColor || '#F0C52C',
        nameAndRankColor: payload.nameAndRankColor || '#D4BFFF',
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        selfInfo: selfInfo,
        ranks: list,
        lastId: lastId,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(fetchGiftInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.activityGiftList);
      const { error, data } = yield call(fetchGiftRankList, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *clearList({ payload }, { call, put }) {
      yield put({
        type: 'updateList',
        payload: { force: true },
      });
    },
  },
};
